import { setImmediateOnce } from "zeta-dom/util";
import { classNames, ToggleFieldProps, useFormField } from "zeta-dom-react";
import { useCheckboxListContext } from ".";

export interface CheckboxProps extends ToggleFieldProps {
    label?: string;
    children?: React.ReactNode;
    description?: string;
    checked?: boolean;
    variant?: 'outlined' | 'switch';
}

export function Checkbox(props: CheckboxProps) {
    const context = useCheckboxListContext();
    const { name, disabled } = context || props;

    // override props if checkbox is belonged to a checkbox list
    // and only attach form events otherwise
    if (context) {
        props = { ...props, name: undefined };
    }
    const { value, error, setValue, elementRef } = useFormField('toggle', props, false);

    let input: HTMLInputElement | null = null;
    return (
        <div ref={elementRef} className={classNames('eac-checkbox', { 'eac-field': !context, variant: props.variant, disabled: disabled, active: value, 'has-error': !!error })}>
            <label className="eac-checkbox-outline">
                <input type="checkbox" ref={v => input = v} name={name} value={props.value || ''} checked={value} disabled={disabled}
                    onChange={() => setImmediateOnce(toggleState)} />
                <div className="eac-checkbox-label">{props.children || props.label}</div>
                {props.description &&
                    <div className="eac-checkbox-description">{props.description}</div>}
                {error && props.showErrorMessage !== false &&
                    <div className="eac-field-error">{error}</div>}
            </label>
        </div>
    );

    function toggleState() {
        const checked = !input?.checked;
        setValue(checked);
        context?.setValue(props.value || '', checked);
    }
}
